import { initErrorFields } from '../../helpers/forms/error/errorFieldHelper';
import { OPERATION_ID, ToRequiredType } from '../typeDef';
import { ProfileInfo } from './user.def';

export interface ProfDef {
  email: string;
  lastname: string;
  firstname: string;
  tel: string;
  classe: OPERATION_ID;
}

export const getProfDef: (user: ProfileInfo) => ProfDef = user => ({
  ...(user as ToRequiredType<ProfileInfo>),
  classe: user.classe.operationid
});

export interface ProfParamsForm {
  email: string;
  firstname: string;
  lastname: string;
  tel: string;
  policy: boolean;
}

const profSchema: ProfParamsForm = {
  firstname: null,
  lastname: null,
  email: null,
  tel: null,
  policy: false
};

export interface ProfParamsForInscriptionOnStrapi extends ProfParamsForm {
  username: string;
  password: string;
  origin: 'register';
}

export interface SignUpFieldType {
  values: ProfParamsForm;
  errors: Record<any, any>;
  isValid: boolean;
  isLoading?: boolean;
}
export const signUpFieldData: SignUpFieldType = {
  values: profSchema,
  errors: initErrorFields(profSchema),
  isValid: false
};

export interface AddNewProfParamsForm {
  email: string;
  tel: string;
  firstname: string;
  lastname: string;
}
interface CreateProfFromMaClassePage {
  values: AddNewProfParamsForm;
  errors: any;
  isValid: boolean;
}
export const profInit: CreateProfFromMaClassePage = {
  values: {
    email: null,
    tel: null,
    firstname: null,
    lastname: null
  },
  errors: {
    email: true,
    firstname: true,
    lastname: true,
    tel: true
  },
  isValid: false
};
